import { useAddAsset } from "web/hooks/data"

import routes from "web/routes/constants"
import { AssetIcon, MapPinIcon } from "web/icons"

export default function PlaceResults({ results, onResultSelected }) {
  const addAsset = useAddAsset()

  async function handleResultClicked(result) {
    if (result.existing_asset) {
      window.Turbo.visit(routes.asset("all", null, result.asset_id))
    } else {
      const { id } = await addAsset({ place_id: result.place_id })
      window.Turbo.visit(routes.asset("all", null, id))
    }

    onResultSelected()
  }

  return (
    <>
      <h2 className="mt-5 text-sm font-medium text-gray-500">Places</h2>
      <div className="mt-3 grid grid-cols-1 gap-3 lg:grid-cols-5">
        {results.map((result) => {
          const PlaceIcon = result.existing_asset ? AssetIcon : MapPinIcon

          return (
            <div
              key={result.place_id}
              className="relative flex items-center space-x-3 rounded-lg border-neutral-9 bg-white px-4 py-5 shadow-sm focus-within:ring-2 focus-within:ring-primary-4 focus-within:ring-offset-2 hover:cursor-pointer hover:border-primary-9 hover:bg-primary-10"
              onClick={() => handleResultClicked(result)}
            >
              <div className="flex-shrink-0 text-neutral-6">
                <PlaceIcon className="h-8 w-8" title="place result" />
              </div>
              <div className="min-w-0 flex-1">
                <span className="absolute inset-0" aria-hidden="true"></span>
                <p className="text-sm font-medium text-neutral-5">
                  {result.name}
                </p>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}
